import { ComponentProps, memo, Suspense } from 'react';
import { Box } from '@alf/uikit';
import { useGetThemeIcons } from '@namespace/themes';
import { IconsMap, iconsMap } from '../icons';

interface Props extends ComponentProps<'svg'> {
  dataRole?: string;
  name: keyof IconsMap | string;
}

// TODO: name suggestions doesn't work because we need to make a typization for theme at first.
//       and then we will have and ability to suggest theme icons as well as default icons
export const IconSVGComponent = memo(
  ({ name, dataRole, className, ...props }: Props) => {
    const iconsSet = useGetThemeIcons();
    const mergedIcons = { ...iconsMap, ...iconsSet };
    const Component = mergedIcons[name as keyof typeof mergedIcons];

    if (!Component) {
      return null;
    }

    return (
      <Suspense
        fallback={
          <Box
            className={className}
            style={{ backgroundColor: 'transparent' }}
          />
        }
      >
        <Component
          data-role={dataRole && `icon-${dataRole}`}
          className={className}
          {...props}
        />
      </Suspense>
    );
  }
);

IconSVGComponent.displayName = 'IconSVGComponent';
